module.exports = __webpack_public_path__ + "img/logo_t.9539cc3f.svg";